import Styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { SchoolInfo } from 'src/school';

type SchoolSearchProps = {
  navigation: number;
  schoolInfo: SchoolInfo | null;
  setHashTags: React.Dispatch<React.SetStateAction<string[]>>;
  guidanceClasses?: string[];
  setGuidanceClass?: React.Dispatch<React.SetStateAction<string>>;
};

const SchoolSearch: React.FC<SchoolSearchProps> = ({ navigation, schoolInfo, setHashTags, guidanceClasses = [], setGuidanceClass }) => {

  const [ selectedDepartment, setSelectedDepartment ] = useState<string | null>(null);
  const [ selectedGrade, setSelectedGrade ] = useState<string | null>(null);
  const [ selectedClass, setSelectedClass ] = useState<string | null>(null);
  const [ selectedGuidanceClass, setSelectedGuidanceClass ] = useState<string>('');

  useEffect(() => {
    const tags: string[] = [];
    if (selectedDepartment) tags.push(selectedDepartment);
    if (selectedGrade) tags.push(selectedGrade);
    if (selectedClass) tags.push(selectedClass);
    setHashTags(tags);
  }, [selectedDepartment, selectedGrade, selectedClass]);

  // コースが1つしかない学校は、それをデフォルトで選択状態にする(未選択だと絞り込む意味がないため)
  useEffect(() => {
    if (selectedDepartment !== null) return;
    const departments = Object.keys(schoolInfo?.departments ?? {});
    if (departments.length === 1) {
      setSelectedDepartment(departments[0]);
    }
  }, [schoolInfo]);

  if (navigation === 4) {
    const allClasses = Array.from(new Set(
      guidanceClasses.length > 0
        ? guidanceClasses
        : Object.values(schoolInfo?.departments ?? {})
            .flatMap(d => Object.values(d?.grades ?? {}).flatMap(g => g?.classes ?? []))
    )).sort((a, b) => {
      const n = (s: string) => Number(s.match(/\d+/)?.[0] ?? 0);
      return n(a) - n(b);
    });

    return (
      <div className={Styles.navigation}>
        <div>
          <p className={Styles.search_title}>クラス</p>
          <div className={Styles.search_tags}>
            <select
              value={selectedGuidanceClass}
              onChange={e => {
                setSelectedGuidanceClass(e.target.value);
                setGuidanceClass?.(e.target.value);
              }}
            >
              <option value=''>未選択</option>
              {allClasses.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
        {selectedGuidanceClass && (
          <button
            type="button"
            className={Styles.reset_btn}
            onClick={() => { setSelectedGuidanceClass(''); setGuidanceClass?.(''); }}
          >
            リセット
          </button>
        )}
      </div>
    );
  }

  return (
    <>
    <div className={Styles.navigation}>
      
      <div>
        <p className={Styles.search_title}>コース</p>
        <div className={Styles.search_tags}>
          <select
            value={selectedDepartment ?? ""}
            onChange={(e) => {
              setSelectedDepartment(e.target.value);
              setSelectedGrade(null);
              setSelectedClass(null);
            }}
          >
            <option value="">未選択</option>
            {Object.keys(schoolInfo?.departments ?? {}).map((dep) => (
                <option key={dep} value={dep}>
                  {dep}
                </option>
              ))}
          </select>
        </div>
      </div>

      {selectedDepartment ? 
      <div>
        <p className={Styles.search_title}>学年</p>
        <div className={Styles.search_tags}>
          <select
            value={selectedGrade ?? ""}
            onChange={(e) => {
              setSelectedGrade(e.target.value);
              setSelectedClass(null);
            }}
          >
            <option value="">未選択</option>
            {Object.keys(schoolInfo?.departments?.[selectedDepartment]?.grades ?? {})
            .sort((a, b) => {
              const numA = Number(a.match(/\d+/)?.[0] ?? 0);
              const numB = Number(b.match(/\d+/)?.[0] ?? 0);
              return numA - numB;
            })
            .map((grade) => (
              <option key={grade} value={grade}>
                {grade}
              </option>
            ))}
          </select>
        </div>
      </div>
      :
      <div>
        <p className={Styles.search_title}>学年</p>
        <div className={Styles.search_tags} style={{opacity: ".5"}}>
          <select>
            <option value="">未選択</option>
          </select>
        </div>
      </div> }

      {navigation !== 4 && (
      <>
        {selectedDepartment && selectedGrade ?
        <div>
          <p className={Styles.search_title}>クラス</p>
          <div className={Styles.search_tags}>
            <select
              value={selectedClass ?? ""}
              onChange={(e) => setSelectedClass(e.target.value)}>
              <option value="">未選択</option>
              {(schoolInfo?.departments?.[selectedDepartment]?.grades?.[selectedGrade]?.classes ?? [])
              .slice()
              .sort((a, b) => {
                const numA = Number(a.match(/\d+/)?.[0] ?? 0);
                const numB = Number(b.match(/\d+/)?.[0] ?? 0);
                return numA - numB;
              })
              .map((cls) => (
                <option key={cls} value={cls}>
                  {cls}
                </option>
              ))}
            </select>
          </div>
        </div>
        :
        <div>
          <p className={Styles.search_title}>クラス</p>
          <div className={Styles.search_tags} style={{opacity: ".5"}}>
            <select>
              <option value="">未選択</option>
            </select>
          </div>
        </div> }
      </>
      )}

      {/* 選んだ条件(コース・学年・クラス)をまとめて外す */}
      {selectedDepartment && (
        <button
          type="button"
          className={Styles.reset_btn}
          onClick={() => { setSelectedDepartment(null); setSelectedGrade(null); setSelectedClass(null); }}
        >
          リセット
        </button>
      )}

    </div>

    </>
  );
}

export default SchoolSearch;
